import * as dataCollectionTypes from '../../consts/uam/dataCollectionTypes';
import {
    setYapSynchronizeDataCollectionInProgress,
    setYapSynchronizeDeviceDataCollectionReceived,
    setYapSynchronizeHolderDataCollectionReceived,
} from '../../state/ducks/yapEncrypted';
import {
    makeSelectIsYapSynchronizeDataCollectionInProgress,
    makeSelectIsYapSynchronizeDataCollectionReceived,
} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';

export const setDataCollectionFlowInProgress = (
    isInProgress,
    dataCollectionType = dataCollectionTypes.DATA_COLLECTION_ALL
) => {
    switch (dataCollectionType) {
        case dataCollectionTypes.DATA_COLLECTION_GLOBAL:
            dispatch(setYapSynchronizeDataCollectionInProgress(isInProgress));
            break;
        case dataCollectionTypes.DATA_COLLECTION_USAGE:
            break;
        case dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC:
            break;
        case dataCollectionTypes.DATA_COLLECTION_ALL:
            dispatch(setYapSynchronizeDataCollectionInProgress(isInProgress));
            break;
        default:
            break;
    }
};

export const setDataCollectionFlowReceived = (props) => {
    const {
        isReceived = false,
        isHolder = false,
        dataCollectionType = dataCollectionTypes.DATA_COLLECTION_ALL,
    } = props || {};

    if (isHolder) {
        switch (dataCollectionType) {
            case dataCollectionTypes.DATA_COLLECTION_GLOBAL:
                dispatch(setYapSynchronizeHolderDataCollectionReceived(isReceived));
                break;
            case dataCollectionTypes.DATA_COLLECTION_USAGE:
                break;
            case dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC:
                break;
            case dataCollectionTypes.DATA_COLLECTION_ALL:
                dispatch(setYapSynchronizeHolderDataCollectionReceived(isReceived));
                break;
            default:
                break;
        }
    } else {
        switch (dataCollectionType) {
            case dataCollectionTypes.DATA_COLLECTION_GLOBAL:
                dispatch(setYapSynchronizeDeviceDataCollectionReceived(isReceived));
                break;
            case dataCollectionTypes.DATA_COLLECTION_USAGE:
                break;
            case dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC:
                break;
            case dataCollectionTypes.DATA_COLLECTION_ALL:
                dispatch(setYapSynchronizeDeviceDataCollectionReceived(isReceived));
                break;
            default:
                break;
        }
    }
};

export const getIsDataCollectionReceived = (dataCollectionType, isHolder) => {
    const state = getState();

    switch (dataCollectionType) {
        case dataCollectionTypes.DATA_COLLECTION_GLOBAL:
            return makeSelectIsYapSynchronizeDataCollectionReceived(isHolder)(state);
        case dataCollectionTypes.DATA_COLLECTION_USAGE:
            return false;
        case dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC:
            return false;
        default:
            break;
    }

    return false;
};

export const getEntitiesToCollect = (dataCollectionType) => {
    switch (dataCollectionType) {
        case dataCollectionTypes.DATA_COLLECTION_GLOBAL:
            return ['SETTINGS', 'USAGE_NEWEST_FIRST', 'ERRORS', 'EVENTS'];
        case dataCollectionTypes.DATA_COLLECTION_USAGE:
            return ['USAGE_NEWEST_FIRST'];
        case dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC:
            return ['ERRORS'];
        default:
            break;
    }
};

export const getCurrentDataCollectionType = () => {
    const state = getState();

    const isYapSynchronizeDataCollectionInProgress = makeSelectIsYapSynchronizeDataCollectionInProgress()(state);

    if (isYapSynchronizeDataCollectionInProgress) return dataCollectionTypes.DATA_COLLECTION_GLOBAL;

    return null;
};

export const isDataCollectionInProgress = (dataCollectionType) => {
    const state = getState();
    const isYapSynchronizeDataCollectionInProgress =
        makeSelectIsYapSynchronizeDataCollectionInProgress()(state) &&
        dataCollectionType === dataCollectionTypes.DATA_COLLECTION_GLOBAL;
    const isYapUsageFlowDataCollectionInProgress = dataCollectionType === dataCollectionTypes.DATA_COLLECTION_USAGE;
    const isDiagnosticFlowDataCollectionInProgress =
        dataCollectionType === dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC;

    if (
        isYapUsageFlowDataCollectionInProgress ||
        isYapSynchronizeDataCollectionInProgress ||
        isDiagnosticFlowDataCollectionInProgress
    )
        return true;

    return false;
};
